export const DICTIONARY_API_KEYS = {
  learners: '8208a0c6-0ca9-4a7d-976a-669f47de68ff',
  intermediate: '78564cd8-e87a-4cb5-a398-560c33471641',
  collegiate: 'e2b39f17-347c-4fc6-8a07-58ce8916625a',
  thesaurus: 'a289bcd3-d7d1-4ef1-8b1e-c13984658ee6'
} as const;

export const API_BASE_URL = 'https://www.dictionaryapi.com/api/v3/references';